import { forwardRef } from 'react';
import { AspectRatio } from '@/components/elements/AspectRatio';
import StarMuxVideo from '@/components/elements/StarMuxVideo';
import { IMuxVideoUploaderMuxAssetEntityResponse } from '@/graphql/__generated__/global/types';
import cn from '@/lib/classNames';
import formatISO from 'date-fns/formatISO';
import { VideoJsonLd } from 'next-seo';

export interface ResponsiveVideoProps {
    aspectRatio?: number;
    className?: string;
    video?: IMuxVideoUploaderMuxAssetEntityResponse;
}

export const ResponsiveVideo = forwardRef<HTMLVideoElement, ResponsiveVideoProps>(({ className, video, aspectRatio, ...props }, ref) => {
    const playbackId = video?.data?.attributes?.playback_id ?? '';
    const thumbnail = `https://image.mux.com/${playbackId}/thumbnail.webp`;
    const title = video?.data?.attributes?.title ?? '';

    return (
        <div className={cn('w-full h-full overflow-hidden flex', className)}>
            <AspectRatio ratio={aspectRatio}>
                <StarMuxVideo
                    ref={ref}
                    className="min-w-full min-h-full absolute object-cover brightness-75"
                    playbackId={playbackId}
                    placeholder={thumbnail}
                    poster={thumbnail}
                    autoPlay
                    playsInline
                    muted
                    loop
                    metadata={{
                        video_title: title,
                    }}
                    {...props}
                />
                <VideoJsonLd
                    keyOverride={video?.data?.id ? video?.data?.id : ''}
                    name={title}
                    description={title}
                    thumbnailUrls={thumbnail}
                    contentUrl={`https://stream.mux.com/${playbackId}/medium.mp4`}
                    uploadDate={video?.data?.attributes?.createdAt ? formatISO(new Date(video.data.attributes.createdAt)) : formatISO(new Date())}
                />
            </AspectRatio>
        </div>
    );
});

ResponsiveVideo.displayName = 'ResponsiveVideo';
